import React, { Component } from "react";
import PropTypes from "prop-types";
  
import "./TeamBrand.scss";

class TeamBrand extends Component {
  static propTypes = {
    defaultImage: PropTypes.string,
    imagePosition: PropTypes.string,
    name: PropTypes.string
  };

  static defaultProps = {
    defaultImage: "",
    imagePosition: "",
    name: ""
  };

  state = {
    image: this.props.defaultImage
  };

  static getDerivedStateFromProps(props, state) {
    if (state.image !== props.defaultImage) {
      return {
        image: props.defaultImage
      };
    }

    return {};
  }

  handleImageError = () => {
    this.setState({
      image:
        "https://1507-globaldots.gcdn.co/SBG3/app-assets/default-team-logo-basketball.png"
    });
  };

  render() {
    const { name, imagePosition } = this.props;
    const { image } = this.state;

    return (
      <div className="team-brand" data-testid="team-brand">
        <img
          src={image}
          alt={name}
          onError={error => this.handleImageError(error)}
          className="team-brand__image"
          style={{
            alignItems: imagePosition === "left" ? "flex-start" : "flex-end"
          }}
        />
        <h1 className="team-brand__name" data-testid="team-brand-name">
          {name}
        </h1>
      </div>
    );
  }
}

export default TeamBrand;
